"use client";

import { useState } from "react";
import { showLoading, showSuccess, showError } from '@/lib/toast';

export default function ToolsPage() {
  const [name, setName] = useState("");
  const [args, setArgs] = useState("[]");
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setError(null);
    
    const toastId = showLoading(`Đang chạy tool "${name}"...`);
    
    try {
      const res = await fetch('/api/tool-call', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, args: JSON.parse(args) }),
      });
      const data = await res.json();
      
      if (!res.ok) throw new Error(data.error || 'request failed');
      
      setResult(data.result);
      showSuccess(`Chạy tool "${name}" thành công!`, toastId);
    } catch (e: any) {
      const errorMsg = e.message || String(e);
      setError(errorMsg);
      showError(`Lỗi khi chạy tool: ${errorMsg}`, toastId);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Tool Runner</h1>
      <div>
        <label>Tool name: </label>
        <input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div style={{ marginTop: 8 }}>
        <label>Arguments (JSON array):</label><br />
        <textarea
          value={args}
          onChange={(e) => setArgs(e.target.value)}
          rows={4}
          style={{ width: '100%' }}
        />
      </div>
      <button onClick={run} style={{ marginTop: 8 }}>Run</button>
      {error && <div style={{ color: 'red' }}>Error: {error}</div>}
      {result !== null && (
        <pre style={{ marginTop: 10, background: '#f0f0f0', padding: 10 }}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
}
